import { NetworkService } from '@toro/common/shared/services/network.services';
import { CadastroSteps } from '@toro/common/shared/enum/cadastro.enum';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
  withLatestFrom,
  exhaustMap,
  switchMap,
  mergeMap,
  map,
  share,
  catchError,
} from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { ErrorsType } from '@toro/common/shared/enum/errors.type';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { BackendService } from '@toro/common/shared/services/backend/backend.service';
import { StockActions } from './stock.action';
import { DefaultResponse } from '@toro/common/shared/models/form/DefaultResponse';
import { StockState } from './stock.reducer';
let VMasker = require('vanilla-masker');

@Injectable()
export class StockEffects {
  /**
   * Obtém datas que possuem movimentações
   * @method getNoteListDate
   */
  @Effect()
  public getNoteListDate$: Observable<any> = this.actions$
    .pipe(
    ofType(StockActions.getNoteListDate),
    withLatestFrom(this.store.select((s) => s.authentication)),
    switchMap(([action, store]) => {
      return this.dataService
        .get<DefaultResponse>('finance/note/listdate')
        .pipe(
        map((result) => {
          if (result.ok) {
            return {
              type: StockActions.getNoteListDateSuccess,
              payload: result.value,
            };
          }
          return {
            type: StockActions.getNoteListDateError,
            payload: { type: ErrorsType.Warning, value: result.messages },
          };
        }),
        catchError((error) =>
          of({
            type: StockActions.getNoteListDateError,
            payload: error,
          }),
        ));
    }),
    share());

  /**
   * Obtem movimentação de opção de uma data
   * @method getBrokageNoteOption
   */
  @Effect()
  public getBrokageNoteOption$: Observable<any> = this.actions$
    .pipe(
			ofType(StockActions.getBrokageNoteOption),
    mergeMap((action: any) => {
      return this.dataService
        .getFile(
          `finance/brokeragenote/option?referenceDate=${encodeURIComponent(
            action.payload,
          )}`,
        )
        .pipe(
        map((result) => {
          if (result.size < 500) {
            return {
              type: StockActions.getBrokageNoteOptionError,
              payload: result,
            };
          }

          const name = `nota-opcao-${action.payload}.pdf`;
          this.networkService.downloadFile(result, name);
          return {
            type: StockActions.getBrokageNoteOptionSuccess,
            payload: result,
          };
        }),
        catchError((error) =>
          of({
            type: StockActions.getBrokageNoteOptionError,
            payload: error,
          }),
        ));
    }),
    share());

  /**
   * Obtem movimentação de futuros de uma data
   * @method getBrokageNoteFuture
   */
  @Effect()
  public getBrokageNoteFuture$: Observable<any> = this.actions$
    .pipe(
			ofType(StockActions.getBrokageNoteFuture),
    mergeMap((action: any) => {
      return this.dataService
        .getFile(
          `finance/brokeragenote/future?referenceDate=${encodeURIComponent(
            action.payload,
          )}`,
        )
        .pipe(
        map((result) => {
          if (result.size < 500) {
            return {
              type: StockActions.getBrokageNoteFutureError,
              payload: result
            };
          }

          const name = `nota-futuro-${action.payload}.pdf`;
          this.networkService.downloadFile(result, name);
          return {
            type: StockActions.getBrokageNoteFutureSuccess,
            payload: result,
          };
        }),
        catchError((error) =>
          of({
            type: StockActions.getBrokageNoteFutureError,
            payload: error,
          }),
        ));
    }),
    share());

  /**
   * Obtem movimentação de bolsa de uma data
   * @method getBrokageNoteStock
   */
  @Effect()
  public getBrokageNoteStock$: Observable<any> = this.actions$
    .pipe(
			ofType(StockActions.getBrokageNoteStock),
    mergeMap((action: any) => {
      return this.dataService
        .getFile(
          `finance/brokeragenote/stock?referenceDate=${encodeURIComponent(
            action.payload,
          )}`,
        )
        .pipe(
        map((result) => {
          if (result.size < 500) {
            return {
              type: StockActions.getBrokageNoteStockError,
              payload: result,
            };
          }

          const name = `nota-acoes-${action.payload}.pdf`;
          this.networkService.downloadFile(result, name);
          return {
            type: StockActions.getBrokageNoteStockSuccess,
            payload: result,
          };
        }),
        catchError((error) =>
          of({
            type: StockActions.getBrokageNoteStockError,
            payload: error,
          }),
        ));
    }),
    share());

    constructor(
      private actions$: Actions<Action>,
      private store: Store<AppState>,
      private networkService: NetworkService,
      private dataService: BackendService,
    ) {}

}
